import SubNav from './SubNav'

class SubNavEmployee extends React.Component {
  render () {
    let links
    let {user, location, subscriptionExpired} = this.props

    if (user.is_owner) {
      links = [
        {
          href: '/employees/list',
          label: 'Staff'
        },
        {
          href: '/employees/permission',
          label: 'Permissions'
        }
      ]
    } else if (user.is_manager) {
      links = [{
        href: '/employees/list',
        label: 'Staff'
      }]
    }

    return <SubNav links={links} location={location} user={user} subscriptionExpired={subscriptionExpired} />
  }
}

SubNavEmployee.propTypes = {
  location: React.PropTypes.object
}

export default SubNavEmployee



// WEBPACK FOOTER //
// ./app/components/SubNav/SubNavEmployee.js